var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 977,
    height: 675,
    viewBox: "0 0 977 675",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_258_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289 454.5L756.5 396L220 220.5L289 454.5Z",
    fill: "#FB3EC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_258_19",
    x: 0,
    y: 0.5,
    width: 976.5,
    height: 674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 110,
    result: "effect1_foregroundBlur_258_19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkGlow);
export default __webpack_public_path__ + "static/media/pinkGlow.0f7be0345e4ebc60fea4e6e3297d731b.svg";
export { ForwardRef as ReactComponent };